import { GetterTree } from 'vuex';
import { HistoryItemType, HistoryState } from '@/features/shipment-history/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<HistoryState, any> = {
  getHistoryItems(state: HistoryState): HistoryItemType[] {
    return state.historyItems;
  },
};

export default getters;
